import { render, staticRenderFns } from "./SequenceElementsMenu.vue?vue&type=template&id=71d31f1c&scoped=true&"
import script from "./SequenceElementsMenu.vue?vue&type=script&lang=js&"
export * from "./SequenceElementsMenu.vue?vue&type=script&lang=js&"
import style0 from "./SequenceElementsMenu.vue?vue&type=style&index=0&id=71d31f1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d31f1c",
  null
  
)

export default component.exports